import { render, staticRenderFns } from "./swiss.vue?vue&type=template&id=31ec70e2&"
import script from "./swiss.vue?vue&type=script&lang=js&"
export * from "./swiss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports